module.exports = __webpack_public_path__ + "static/media/silueta.7eaf1956.jpg";